// Import from Config
// -------------------------------------
import { appConfig } from 'config/initializers/config.app';

// Import from Files
// -------------------------------------
import { FetchRequest } from './FetchRequest';
import { AxiosRequest } from './AxiosRequest';

const extendClass = appConfig.axiosEnabled ? AxiosRequest : FetchRequest;

class Request extends extendClass {}


export { Request };


// WEBPACK FOOTER //
// ./src/backend/communication/Request.js